import React, { HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { IconElements } from '../../../config/icons';
import { useWindowBreakpoints } from '../../../hooks/useWindowBreakpoints';

export const ProgressButtons: React.FC<{ page: number } & HTMLProps<HTMLDivElement>> = ({ page, className }) => {
    const { t } = useTranslation('pension');
    const breakpoints = useWindowBreakpoints();

    const getPageLabelText = (pageId: number, currentPage: number) => {
        if (breakpoints.isMobile) {
            return pageId.toString();
        } else if (breakpoints.isTablet) {
            if (pageId === currentPage + 1) {
                return getPageLabelTextByIdx(pageId);
            } else {
                return pageId.toString();
            }
        } else {
            return getPageLabelTextByIdx(pageId);
        }
    };

    const getPageLabelTextByIdx = (pageId: number) => {
        switch (pageId) {
            case 1:
                return t('pension-cocktail-fill-screen-button-personal');
            case 2:
                return t('pension-cocktail-fill-screen-button-expenses');
            case 3:
                return t('pension-cocktail-fill-screen-button-pension');
            default: // Case 4
                return t('pension-cocktail-fill-screen-button-supplemental');
        }
    };

    return (
        <div className={`${className}`}>
            <div className="flex flex-row gap-2 lg:gap-4 flex-wrap">
                <ProgressLabel phase={page === 1 ? 'current' : 'prev'} step={page} text={getPageLabelText(1, page)} />
                <ProgressLabel
                    phase={page < 2 ? 'inc' : page > 2 ? 'prev' : 'current'}
                    step={page}
                    text={getPageLabelText(2, page)}
                />
                <ProgressLabel
                    phase={page < 3 ? 'inc' : page > 3 ? 'prev' : 'current'}
                    step={page}
                    text={getPageLabelText(3, page)}
                />
                <ProgressLabel
                    phase={page < 4 ? 'inc' : page > 4 ? 'prev' : 'current'}
                    step={page}
                    text={getPageLabelText(4, page)}
                />
            </div>
        </div>
    );
};

const ProgressLabel: React.FC<{ text: string; phase: 'current' | 'prev' | 'inc'; step: number }> = ({
    text,
    phase,
    step,
}) => {
    return (
        <div
            className={`${phase === 'inc' ? 'text-bnd-black-60' : 'text-bnd-white-1'} ${
                phase === 'current'
                    ? 'bg-bnd-blue px-4'
                    : phase === 'prev'
                    ? 'bg-bnd-green px-3'
                    : 'bg-bnd-black-10 px-4 '
            } block relative text-center truncate focus:outline-hidden leading-10 rounded-full`}
        >
            {phase === 'inc' ? (
                text
            ) : phase === 'current' ? (
                step
            ) : (
                <IconElements.Check className="text-white inline rounded-full w-4 h-4" />
            )}
        </div>
    );
};
